import { PlayIcon } from "@/svg";
import styles from "./ButtonPlayNow.module.scss";
import { PlayNowButtonProps } from "./type";

export const PlayNowButton: React.FC<PlayNowButtonProps> = ({ title, onClick }) => (
  <button type="button" aria-label="Button play now" onClick={onClick} className={styles.button}>
    <PlayIcon />
    <span>{title}</span>
  </button>
);
